var _circle, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepLogoSecond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 87,
    r: 84,
    fill: "#FFF6F0",
    stroke: "#FF9A53",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_848_20208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.909 75.6479C136.565 75.6125 136.218 75.6125 135.873 75.6479H65.1569C64.7037 75.6549 64.2535 75.7229 63.8184 75.85L100.313 112.193L136.909 75.6479Z",
    fill: "#FF9A53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.986 79.2341L103.274 115.918C102.329 116.861 101.051 117.39 99.7191 117.39C98.3868 117.39 97.1087 116.861 96.1639 115.918L59.78 79.5124C59.6682 79.9249 59.6089 80.35 59.6035 80.7774V131.376C59.6035 132.718 60.1348 134.005 61.0805 134.954C62.0262 135.903 63.3089 136.436 64.6463 136.436H135.246C136.583 136.436 137.866 135.903 138.811 134.954C139.757 134.005 140.288 132.718 140.288 131.376V80.7774C140.268 80.2503 140.166 79.7296 139.986 79.2341ZM68.1006 131.376H64.5959V127.758L82.9265 109.518L86.4817 113.085L68.1006 131.376ZM135.195 131.376H131.665L113.284 113.085L116.839 109.518L135.17 127.758L135.195 131.376Z",
    fill: "#FF9A53"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_848_20208)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.7227,
    y: 43.7085,
    width: 66.2339,
    height: 45.7616,
    fill: "#FFF6F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2557 84.3594V69.9573L52.9511 58.2618C53.0709 58.1422 53.2332 58.0751 53.4024 58.0751C53.5716 58.0751 53.7339 58.1422 53.8537 58.2618L75.545 79.949C76.0543 80.4858 76.6645 80.9173 77.3407 81.2186C78.0323 81.5268 78.779 81.6925 79.5361 81.7058C80.2932 81.7192 81.0452 81.5799 81.7473 81.2963L80.811 78.9783L81.7473 81.2963C82.4494 81.0127 83.0872 80.5906 83.6226 80.0552C84.1581 79.5198 84.5802 78.882 84.8638 78.1799C85.1474 77.4778 85.2866 76.7257 85.2733 75.9687C85.2599 75.2115 85.0942 74.4649 84.786 73.7732C84.4847 73.097 84.0532 72.4869 83.5164 71.9776L83.3444 71.8055L89.568 65.5852C89.6877 65.4656 89.85 65.3984 90.0192 65.3984C90.1884 65.3984 90.3507 65.4656 90.4705 65.5852L99.0274 74.1382V84.3594C99.0274 84.5287 98.9601 84.6912 98.8403 84.8109L100.608 86.5787L98.8403 84.8109C98.7206 84.9307 98.5581 84.998 98.3888 84.998H41.8943C41.5425 84.998 41.2557 84.7112 41.2557 84.3594ZM33.4686 36.1783L35.2363 37.946L33.4686 36.1783C31.2339 38.4129 29.9785 41.4437 29.9785 44.604V84.3594C29.9785 87.5196 31.2339 90.5505 33.4686 92.7851C35.7032 95.0197 38.734 96.2751 41.8943 96.2751H98.3888C99.9536 96.2751 101.503 95.9669 102.949 95.3681C104.394 94.7693 105.708 93.8916 106.814 92.7851C107.921 91.6786 108.799 90.365 109.397 88.9193C109.996 87.4736 110.305 85.9242 110.305 84.3594V44.604C110.305 43.0392 109.996 41.4897 109.397 40.044C108.799 38.5983 107.921 37.2848 106.814 36.1783C105.708 35.0718 104.394 34.1941 102.949 33.5953C101.503 32.9964 99.9536 32.6882 98.3888 32.6882H41.8943C38.734 32.6882 35.7032 33.9436 33.4686 36.1783ZM76.0111 51.9273C76.0111 52.3742 75.8336 52.8027 75.5176 53.1187C75.2017 53.4346 74.7731 53.6121 74.3263 53.6121C73.8795 53.6121 73.4509 53.4346 73.135 53.1187C72.819 52.8027 72.6415 52.3742 72.6415 51.9273C72.6415 51.4805 72.819 51.052 73.135 50.736C73.4509 50.4201 73.8795 50.2426 74.3263 50.2426C74.7731 50.2426 75.2017 50.4201 75.5176 50.736C75.8336 51.052 76.0111 51.4805 76.0111 51.9273Z",
    fill: "#FF9A53",
    stroke: "#FFF6F0",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_848_20208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.9211,
    height: 90.9211,
    fill: "white",
    transform: "translate(54.7871 60.5681)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_848_20208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.6956,
    height: 83.6956,
    fill: "white",
    transform: "translate(28.293 22.634)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepLogoSecond);
export default __webpack_public_path__ + "static/media/step-logo-second.3ebdcd4e88b7f08cb3db5644ef0a4235.svg";
export { ForwardRef as ReactComponent };